import { Button } from "@jdoc/ui";
import { useWorkspace } from "@/state/workspaceStore";
import { IconClose, IconJDocApp } from "./icons";
import { MobileNavMenu } from "./landing/MobileNavMenu";

export function AppHeader() {
  const session = useWorkspace((s) => s.session);
  const closeDocument = useWorkspace((s) => s.closeDocument);

  return (
    <header className="flex h-16 shrink-0 items-center justify-between border-b border-slate-200 bg-white px-4 sm:px-6">
      <div className="flex items-center gap-2">
        <IconJDocApp />
        <span className="text-xl font-bold tracking-tight text-slate-900">JDoc</span>
        <span className="flex items-center gap-1.5 text-xs text-slate-500">
          by{" "}
          <img
            src="/images/logo-jtech.png"
            alt="JTech"
            className="h-4 w-auto object-contain"
          />
          <span className="font-semibold text-slate-700">JTech</span>
        </span>
      </div>

      {session && (
        <div className="flex min-w-0 items-center gap-2 rounded-md bg-slate-100 px-3 py-1 text-sm">
          <span className="truncate" title={session.displayName}>
            {session.displayName}
          </span>
          <span className="rounded bg-slate-200 px-1.5 py-0.5 text-xs font-medium uppercase text-slate-600">
            {session.kind}
          </span>
          {session.dirty && (
            <span
              className="h-2 w-2 rounded-full bg-amber-500"
              title="Unsaved changes"
              aria-label="Unsaved changes"
            />
          )}
        </div>
      )}

      <div className="ml-auto flex items-center gap-3">
        {!session && (
          <>
            {/* Desktop nav */}
            <nav
              aria-label="Primary"
              className="hidden items-center gap-5 sm:flex"
            >
              <a
                href="https://jtechuk.com/jdoc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
              >
                How it works
              </a>
              <a
                href="https://jtechuk.com/jdoc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
              >
                Privacy
              </a>
              {/* Status label, not an action — kept as text per design spec. */}
              <span className="inline-flex items-center rounded-lg border border-brand-500 px-3 py-1.5 text-sm font-semibold text-brand-600">
                Free to use
              </span>
            </nav>
            {/* Mobile menu */}
            <MobileNavMenu />
          </>
        )}
        {session && (
          <Button variant="ghost" size="sm" onClick={closeDocument}>
            <IconClose />
            <span className="hidden sm:inline">Close</span>
          </Button>
        )}
      </div>
    </header>
  );
}

